import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import useToken from 'hooks/useToken';
import { useNavigate } from 'react-router-dom';
import { useToast } from 'context/providers/ToastProvider';

const DescargarPDF = ({
    idFactura,
    vUUIDFactura }) => {

    const { showErrorToast, showSuccessToast } = useToast();
    const { token, setToken } = useToken();
    const navigate = useNavigate();

    const handleClick = async () => {
        try {
            const id = idFactura;

            if (!id) {
                showErrorToast('No se pudo determinar el ID de la factura.');
                return;
            }

            showSuccessToast('Iniciando descarga de PDF...');

            const url = `/api/Facturas/GenerarPdfFactura?idFactura=${encodeURIComponent(id)}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });

            if (response.ok) {
                const blob = await response.blob();
                const downloadName = vUUIDFactura ? `${vUUIDFactura}.pdf` : `Factura_${id}.pdf`;
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = downloadName;
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                if (response.status === 401) {
                    setToken(null);
                    navigate('/');
                    return;
                }
                const err = await response.json().catch(() => null);
                showErrorToast(err?.vMessage || `Error al descargar PDF: ${response.status} ${response.statusText}`);
            }

        } catch (error) {
            showErrorToast('Error al descargar PDF: ' + error);
        }
    };

    return (
        <Dropdown.Item onClick={handleClick}>
            <FontAwesomeIcon icon={faFilePdf} className="me-2" />
            Descargar PDF
        </Dropdown.Item>
    );
};

DescargarPDF.propTypes = {
    idFactura: PropTypes.number,
    vUUIDFactura: PropTypes.string
};

export default DescargarPDF;
